/**
 * Exports origin based on window location properties
 * Support for window.location.origin property in IE
 * */
const { protocol, hostname, port } = window.location;

export const locationOrigin = `${protocol}//${hostname}`;

export const originPort = port;
